
import { Vue, Prop, Component } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

interface Item {
  name: string;
  img: string;
}

@Component
export default class BusinessMerchants extends Vue {
  @Prop({ type: Array, required: true }) list!: Item[];

  showMore = false
  
  get isH5() {
    return AppModule.isH5
  }

  toggleMerchants () {
    this.showMore = !this.showMore
    if (!this.showMore) {
      const merchants = this.$refs.merchants as HTMLElement
      merchants.scrollIntoView({ behavior: 'smooth' })
    }
  }

}
